module.exports = __webpack_public_path__ + "img/alter-ego_cn.c0e52c9.jpg";